import { memo, useContext } from "react";
import { AppConfigContext } from "../../core/AppConfigContext";
import { DateUtilsContext } from "../../core/DateUtilsContext";
import { BaseDateTimeRendererProps } from "./types";

export type TimeRendererProps = BaseDateTimeRendererProps;

export const TimeRenderer = memo<TimeRendererProps>(({ value, dateFormat, timeZone }) => {
  const appConfig = useContext(AppConfigContext);
  const { formatDateString } = useContext(DateUtilsContext);

  return (
    <>
      {formatDateString(value, dateFormat || appConfig?.timeFormat, timeZone || appConfig?.timeZone)}
    </>
  );
});
